const Promise = require('es6-promise').Promise;

/**
 * FileRequest
 * @class
 */
class FileRequest {

  /**
   * @static
   * @return {object} options
   */
  static get defOpts() {
    return {
      credentials: 'same-origin',
    }
  }

  /**
   * @instance
   * @param _url {string}
   * @param _opts {object}
   */
  constructor(_url, _opts = {}) {
    this.opts = _.defaults(_opts, FileRequest.defOpts);
    this.url  = _url;
  }

  /**
   * @instance
   * @param _opts {object}
   */
  request(_opts) {
    const opts_ = _.defaults(_opts, this.opts);

    return new Promise( (_resolve) => {
      fetch(this.url, opts_)
      .then( (_response) => {
        if(_response.status === 200) {
          this.success();
        } else {
          this.failure();
        }
        this.complete();
        return _response.json();
      })
      .then( (_data) => {
        _resolve(_data);
      })
      .catch( (_err) => {
        _resolve(_err);
      });
    });
  }

  /**
   * @instance
   */
  success() {}

  /**
   * @instance
   */
  failure() {}

  /**
   * @instance
   */
  complete() {}

}

/**
 * class exports
 */
module.exports = FileRequest;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/request/file-request.js
 **/